module.exports = __webpack_public_path__ + "img/news3.0056446a.png";